import { BlockType, ButtonCategory, ButtonType, StepData } from '@shared/models/step.model';
import { EntityStatus } from '@shared/models/menu.model';

export const getMockStepDataWithCertificateButton = (stepId: number, stepStatus: EntityStatus): StepData => {
  return {
    id: stepId,
    title: 'Step 6',
    name: 'Wrap-up documents',
    description: '2 minutes',
    congrats: '<p>Well done, your progress has been saved. Continue to your next step below.</p>',
    hideStepInMenu: false,
    breadcrumbs: 'Level 1 &bull; Your progress &bull; Step 6',
    prev_page_url: '/potentialife-course/cycle-1/module-10-1/step-5',
    next_page_url: '/home',
    fullUrl: '/potentialife-course/cycle-1/module-10-1/step-6',
    slug: 'step-6',
    status: stepStatus,
    blocks: [
      {
        id: 3663,
        element: BlockType.button,
        source_program_data_code: null,
        program_data_code: null,
        data: {
          name: 'button3663',
          category: ButtonCategory.certificate,
          type: ButtonType.pdf,
          color: null,
          href: 'https://cdn.potentialife.com/level-1/module-11/Certificate_completion_IgniteNEW.json',
          label: 'Certificate of Completion',
          position: 'center',
        },
      },
      {
        id: 2966,
        element: BlockType.button,
        source_program_data_code: null,
        program_data_code: null,
        data: {
          name: 'button2966',
          type: ButtonType.link,
          color: null,
          href: "https://cdn.potentialife.com/level-1/module-11/Potentialife+-+Tal's+Level+1+Reading+List.pdf",
          label: "Tal's reading list",
          position: 'center',
        },
      },
      {
        id: 3615,
        element: BlockType.feedback,
        source_program_data_code: null,
        program_data_code: 'l2.lifemap.feedback_rating',
        data: {
          label_stars: 'How would you rate this module?',
          label_text: 'Thank you for your feedback!',
          placeholder_text: '(Optional) Suggest improvements...',
          config: {
            program_data_code_feedback_text: 'l2.lifemap.feedback_text',
          },
          rating_value: '3',
          feedback_text: null,
        },
      },
    ],
  };
};
